import { useCallback, useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
// * hooks
import {
  useDeleteRewardMutation,
  useRewardItemsList,
} from "../../hooks/rewardQueries";
import { useAuth } from "../../services/auth";
import CustomImage from "../CustomImage";

const RewardList = () => {
  const { authData } = useAuth();

  const { status, data, isFetching } = useRewardItemsList(
    "fb507a0b75e0f62f65b798424555733f"
    // authData?.token ?? ""
  );

  const queryClient = useQueryClient();
  const listRefresh = useCallback(() => {
    queryClient.invalidateQueries(["rewardItem", { type: "list" }]);
  }, [queryClient]);
  const { mutate: deleteMutate, isLoading: isDeleting } =
    useDeleteRewardMutation(
      "fb507a0b75e0f62f65b798424555733f",
      listRefresh,
      listRefresh
    );
  const onEdit = useCallback((id: number) => {}, []);
  const onDelete = useCallback(
    (id: number) => {
      if (!isDeleting) {
        deleteMutate(id.toString());
      }
    },
    [deleteMutate, isDeleting]
  );

  useEffect(() => {
    if (status === "success") {
      console.log("data", data);
    }
  }, [status, data]);

  return status === "success" ? (
    <div className="border-t border-orange-500">
      {[...data].map((rewardItem: any) => (
        <RewardItem
          {...rewardItem}
          onEdit={() => onEdit(rewardItem.id)}
          onDelete={() => onDelete(rewardItem.id)}
          key={`reward-item-${rewardItem.id}`}
        />
      ))}
    </div>
  ) : (
    <div className="border-t border-orange-500">Loading...</div>
  );
};

export default RewardList;

const RewardItem = (props: any) => {
  return (
    <div className="p-1 flex border border-t-0 border-orange-500 items-center">
      <h4 className="w-20 truncate">{props.name}</h4>
      {/* <img className=""></img> */}
      <div className="ml-4 h-10 w-10">
        <CustomImage
          objectKey={props.objectkey}
          token="fb507a0b75e0f62f65b798424555733f"
        />
      </div>
      <div className="ml-4 w-20 truncate">{props.Interest.name}</div>
      <a href={props.link} className="w-[260px] truncate text-orange-500">
        {props.link}
      </a>
      <div className="ml-4 flex-1 truncate">{props.discount}</div>
      <div className="ml-4 w-28 truncate">{props.couponCode}</div>
      <div className="ml-4 w-8">{props.point}</div>
      <div
        onClick={props.onEdit}
        className="ml-2 w-6 h-6 rounded-md bg-lime-400 cursor-pointer text-center text-base align-middle hover:opacity-40"
      >
        e
      </div>
      <div
        onClick={props.onDelete}
        className="ml-2 w-6 h-6 rounded-md bg-orange-500 cursor-pointer text-center text-base align-middle hover:opacity-40 "
      >
        x
      </div>
    </div>
  );
};
